import { useRouter } from 'next/router';
import { PortableText } from '@portabletext/react';
import styles from './styles.module.scss';
import { portableTextComponents } from '@/lib/portableTextComponents';

export default function PageHeading({ children, text, backgroundColor }) {
  const router = useRouter();
  const isHome = router.pathname === '/' || router.asPath === '/';

  const bgStyle = backgroundColor?.hex
    ? { backgroundColor: backgroundColor.hex }
    : {};

  const paddingStyle = {
    padding: isHome ? '1rem' : '2rem',
  };

  return (
    <section
      className={styles.pageHeading}
      style={{ ...bgStyle, ...paddingStyle }}
    >
      <div className={styles.content}>
        {children ? (
          <h1>{children}</h1>
        ) : Array.isArray(text) && text.length > 0 ? (
          <PortableText value={text} components={portableTextComponents} />
        ) : null}
      </div>
    </section>
  );
}